import { Box, TextField } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import { isFunction } from "lodash";
import { useState } from "react";
import { tokens } from "styles/Tokens";
import Typography from "./Typography";
import Validation from "./Validation";

interface Props {
  name?: string;
  register?: (val1: any, val2: any) => void | object;
  error?: any;
  validations?: any;
  label?: string;
  placeholder?: string;
  handleChangeUpdate?: (val: any) => void;
  onChange?: any;
  textVariant?: string;
  color?: string;
  variant?: "outlined" | "standard" | "filled";
  value?: any;
  disabled?: boolean;
  isMultiline?: boolean;
  rowsCount?: number;
  maxRowsCount?: number;
  sx?: any;
  inputProps?: any;
  startAdornment?: any;
  type?: string;
  numeric?: boolean;
  maxLength?: number;
}

function Input(props: Props) {
  const {
    label,
    placeholder,
    handleChangeUpdate,
    textVariant = "body2",
    color,
    variant = "outlined",
    value,
    disabled,
    register,
    name,
    error,
    validations,
    isMultiline,
    rowsCount,
    maxRowsCount,
    sx,
    inputProps,
    onChange,
    startAdornment,
    type,
    numeric,
    maxLength
  } = props;

  const [inputValue, setInputValue] = useState(value || "");

  const handleChange = (event: any) => {
    setInputValue(event.target.value || "");
    if (handleChangeUpdate) {
      handleChangeUpdate(event.target.value);
    }
  };

  const getProps = () => {
    let props: any = { maxLength };
    if (isFunction(register)) {
      props = { ...register(name, validations), ...props };
    }
    if (numeric) {
      props = { ...props, type: "number", pattern: "[0-9]*", min: 0 };
    }
    return props;
  };

  return (
    <>
      <Box width="100%" textAlign="left">
        {label && (
          <>
            <Typography component="span" color={tokens.Text.Feedback.Alert}>
              {validations?.required ? " * " : ""}
            </Typography>
            <Typography component="span" variant={textVariant} color={color} textAlign="left">
              {label}
            </Typography>
          </>
        )}
        <TextField
          name={name}
          type={type}
          disabled={disabled}
          multiline={isMultiline}
          rows={rowsCount}
          maxRows={maxRowsCount}
          fullWidth={true}
          sx={{
            margin: "4px 0",
            "& input::placeholder": {
              fontSize: "14px",
              color: tokens.Border.General.Secondary,
              opacity: 1
            },
            ...sx,
            ".MuiOutlinedInput-notchedOutline": { borderColor: error ? tokens.Border.Feedback.Alert : "inherit" }
          }}
          defaultValue={value}
          InputProps={{
            startAdornment: <InputAdornment position="start">{startAdornment}</InputAdornment>,
            sx: { ...inputProps }
          }}
          inputProps={getProps()}
          placeholder={placeholder}
          onChange={isFunction(onChange) ? onChange : handleChange}
          id="outlined-basic"
          variant={variant}
        />

        {maxLength && (
          <div>
            <Typography variant={"label"}>
              {inputValue?.length === maxLength
                ? `You have reached the limit`
                : `${inputValue?.length || 0}/${maxLength}`}
            </Typography>
          </div>
        )}
        {error && <Validation name={name} type={error?.type} message={error.message} />}
      </Box>
    </>
  );
}

export default Input;
